import React from 'react'

import { CMSImage, Props as ImageProps } from '@/ui/atoms/CMSImage'
import { MediaBlock as MediaBlockType } from '@/payload-types'
import { cn } from '@/utils/ui'

// A base64 encoded image to use as a placeholder while the image is loading

export const ImageMedia: React.FC<ImageProps & MediaBlockType> = (props) => {
  const { objectFit, aspectRatio, showBorder } = props
  const { link, linkNewTab } = props as MediaBlockType & { link?: string | null; linkNewTab?: boolean | null }

  //change the media key to resource key in the props object

  const imageProps = props.image

  const image = (
    <CMSImage
      {...imageProps}
      className={cn('w-full rounded-md', {
        'border-[1px]': showBorder,
      })}
      style={{
        aspectRatio: aspectRatio ?? 'auto',
        objectFit: aspectRatio !== 'auto' && objectFit ? objectFit : 'inherit',
      }}
    />
  )

  return (
    <div className={'relative w-full'}>
      {link ? (
        <a
          href={link}
          className={'block'}
          {...(linkNewTab ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
        >
          {image}
        </a>
      ) : (
        image
      )}
    </div>
  )
}
